// @import dependencies
import React, {Component} from 'react'
import { store } from 'app_storage/redux-storage'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {MyCoursesModuleLayout} from 'app_components/modules/campus/academic/myCourses'
// @end

// @import events
import { courseSelectedChange, courseTabChange } from 'app_events/courses/actions';
// @end

// @import utils
// @end

// @import services
import CourseService from 'app_services/campus/academic/courseService'
// @end

// @import types
import {IMyCourse, IMyCourseTab} from 'app_types/campus/academic/myCoursesTypes'
import { CourseSchedulingStatus } from 'app_types/admin/courseScheduling/courseSchedulingTypes'
// @end

// @ADD Component types
interface IMyCoursesModuleProps {
  role?: string
}
interface IMyCoursesModuleState {
  current_courses: Array<IMyCourse>
  history_courses: Array<IMyCourse>
  status: 'loading' | 'error' | null
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class MyCoursesModule extends Component<IMyCoursesModuleProps, IMyCoursesModuleState> {

  private courseService: CourseService
  private storeObject = store

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IMyCoursesModuleProps) {
    super(props)

    this.state = {
      status: 'loading',
      current_courses: [],
      history_courses: []
    }

    this.courseService = new CourseService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    this.fetchMyCourses()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {
    // this.handleCourseSelectedChange(null)
  }

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  fetchMyCourses = async () => {

    let auth = this.storeObject.getState().auth

    if (auth?.user?.data?.moodle?.moodle_id) {
      const dataResponse = await this.courseService.fetchMyCourses({userid: auth?.user?.data?.moodle?.moodle_id})
      if (dataResponse) {
        this.setState(({
          status: null,
          current_courses: (dataResponse.current_courses) ? dataResponse.current_courses : [],
          history_courses: (dataResponse.history_courses?.filter(register => register.schedulingStatus?.name !== CourseSchedulingStatus.CANCELED))
          ? dataResponse.history_courses?.filter(register => register.schedulingStatus?.name !== CourseSchedulingStatus.CANCELED)
          : []
        }))
      }
    }

    this.setState(({status: null}))
  }

  /**
   * Metodo que permite cambiar el curso seleccionado y desencadenar los eventos necesarios
   * @param course
   */
  handleCourseSelectedChange = (course: IMyCourse | null) => {
    this.storeObject.dispatch(courseSelectedChange(course))
  }

  handleCourseTabChange = (tab: IMyCourseTab) => {
    this.storeObject.dispatch(courseTabChange(tab))
  }

  render() {
    return(
      <MyCoursesModuleLayout
        status={this.state.status}
        current_courses={this.state.current_courses}
        history_courses={this.state.history_courses}
        handleCourseSelectedChange={this.handleCourseSelectedChange}
        handleCourseTabChange={this.handleCourseTabChange}
        role={this.props.role}
      />
    )
  }
}

export default connect(mapStatesToProps)(MyCoursesModule)
